import * as yup from 'yup'

/**
 * Create `yup` validation schema for dictinoary schema
 *
 * @param schema Value schema
 *
 * @returns
 */
export function dictionarySchema<T, K extends string | number | symbol = string | number | symbol>(
  schema: yup.Schema<T>,
): yup.Schema<Record<K, T>> {
  return yup
    .mixed()
    .transform(value => Object.fromEntries(
      Object
        .entries(value || {})
        .map(([id, value]) => [
          id,
          schema.cast(value, {
            stripUnknown: true,
            assert: false,
          }),
        ])
    ))
    .test({
      name: 'dictionary-object',
      message: 'Ошибка в объекте-словаре',
      test: (value) => Object
        .values(value)
        .every(item => schema.validateSync(item)),
    }) as yup.Schema<any>;
}
